import { useMutation, useQueryClient } from '@tanstack/react-query';
import { orpc } from '@/api/rpc/client';

/**
 * Hook to dismiss an AI suggestion (soft hide, doesn't reject)
 * Use this instead of reject when the user just wants to hide the suggestion.
 */
export function useDismissAiSuggestion(onSuccess?: () => void) {
  const queryClient = useQueryClient();

  return useMutation({
    ...orpc.ai.suggestions.dismiss.mutationOptions(),
    onSuccess: (data) => {
      // Invalidate the specific suggestion query using its ID
      queryClient.invalidateQueries({
        queryKey: orpc.ai.suggestions.get.key({ input: { id: data.id } }),
      });
      // Also invalidate all ai.suggestions queries (broader match)
      queryClient.invalidateQueries({
        queryKey: orpc.ai.suggestions.get.key(),
      });
      queryClient.invalidateQueries({
        queryKey: ['accounts-receivable', 'sales-order-drafts'],
      });
      onSuccess?.();
    },
  });
}
